const getDayMonthYearFromTime = (timestamp?: number): Maybe<DayMonthYear> => {
  if (!timestamp) {
    return undefined;
  }
  const date = unixTimestampToDate(timestamp);
  return {
    day: date.getUTCDate(),
    month: date.getUTCMonth() + 1,
    year: date.getUTCFullYear(),
  };
};

const unixTimestampToDate = (value: number): Date => new Date(value * 1000);

export default getDayMonthYearFromTime;
